import React from 'react';
import Divider from "@material-ui/core/Divider";
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    position: 'relative'
  },
  label: {
    position: 'relative',
    marginTop: -10,
    margin: 'auto',
    width: 100,
    background: 'white',
    textAlign: 'center',
  },
}));

const DividerBlock = ({ index, block }) => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <Divider />
      <div className={classes.label}>Page Break</div>
    </div>
  )
};

export default DividerBlock;
